import { History } from 'lucide-react';

interface LastUsedLoginBadgeProps {
  label: string;
}

export function LastUsedLoginBadge({ label }: LastUsedLoginBadgeProps) {
  return (
    <span className="pointer-events-none absolute -top-2 right-3 inline-flex items-center gap-1 rounded-full border border-lime-300/40 bg-gray-950 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-lime-200 shadow-sm shadow-black/30">
      <History className="h-2.5 w-2.5" aria-hidden="true" />
      {label}
    </span>
  );
}
